import React from 'react';
import { parseISO, format } from 'date-fns';

export default function DescriptionDate(props) {
  return (
    <div>
      {props.description.map((a, i) => {
        if (a.count === 0) {
          return (
            <div key={i} className="flex-row" style={{ margin: 1 }}>
              <div
                className="flex-row justify-center align-center non-working-day box-working-day"
                style={{ minWidth: 133 }}
              >
                <div className="flex-row justify-center" style={{ width: 25 }}>
                  X
                </div>
                {' - ' + format(parseISO(a.date), 'dd/MM/yyyy')}
              </div>
              <div
                className="flex-row justify-center self-align-center"
                style={{ padding: '0px 3px 0px 3px' }}
              >
                -
              </div>
              <div className="flex-row justify-center self-align-center">
                {a.description ? a.description : 'Dia não útil'}
              </div>
            </div>
          );
        }
        return (
          <div
            key={i}
            className="flex-row"
            style={{ margin: 1, fontWeight: 'bold' }}
          >
            <div
              className="flex-row justify-center align-center working-day box-working-day"
              style={{ minWidth: 133 }}
            >
              <div className="flex-row justify-center" style={{ width: 25 }}>
                {a.count}
              </div>
              <div>{' - ' + format(parseISO(a.date), 'dd/MM/yyyy')}</div>
            </div>
            <div
              className="flex-row justify-center self-align-center"
              style={{ padding: '0px 3px 0px 3px' }}
            >
              -
            </div>
            <div className="flex-row justify-center self-align-center">
              {a.description ? a.description : 'Dia não útil'}
            </div>
          </div>
        );
      })}
    </div>
  );
}
